import React from 'react';
import ApprovalDelegationContainer from '../../containers/approvalmng/ApprovalDelegationContainer';

const ApprovalDelegationPage = () => {
  return <ApprovalDelegationContainer />;
};

export default ApprovalDelegationPage;
